import { render, staticRenderFns } from "./DonorCBC.vue?vue&type=template&id=77a347c3"
import script from "./DonorCBC.vue?vue&type=script&lang=js"
export * from "./DonorCBC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports